// Views

// Components
import jsCursor from '../components/jsCursor'

const glob = {
  init() {
    jsCursor.init()
  },
  load() {}
}
export default glob
